import React from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';
import { useTranslation } from 'react-i18next';
import { Card, CardContent } from './ui/card';
import { Stethoscope, Heart, Activity } from 'lucide-react';

const AboutSection = () => {
  const { t } = useTranslation();
  const sectionRef = useScrollReveal();

  const highlights = [
    {
      icon: Stethoscope,
      title: t('aboutDoctor.highlights.generalMedicine'),
      description: t('aboutDoctor.highlights.generalMedicineDesc')
    },
    {
      icon: Activity,
      title: t('aboutDoctor.highlights.criticalCare'),
      description: t('aboutDoctor.highlights.criticalCareDesc')
    },
    {
      icon: Heart,
      title: t('aboutDoctor.highlights.patientCentered'),
      description: t('aboutDoctor.highlights.patientCenteredDesc')
    }
  ];

  return (
    <section id="about" className="py-20 px-4 bg-white" ref={sectionRef}>
      <div className="container mx-auto max-w-6xl">
        <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4 text-center scroll-reveal">
          {t('aboutDoctor.title')}
        </h2>
        <div className="w-20 h-1 mx-auto mb-12 scroll-reveal" style={{ backgroundColor: 'var(--medical-primary)', animationDelay: '0.1s' }}></div>

        <div className="max-w-3xl mx-auto mb-12">
          <p className="text-lg text-slate-700 leading-relaxed mb-6 scroll-reveal" style={{ animationDelay: '0.2s' }}>
            {t('aboutDoctor.para1')}
          </p>
          <p className="text-lg text-slate-700 leading-relaxed scroll-reveal" style={{ animationDelay: '0.3s' }}>
            {t('aboutDoctor.para2')}
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {highlights.map((item) => {
            const Icon = item.icon;
            return (
              <Card 
                key={item.title}
                className="card-hover scroll-reveal-scale" 
                style={{ 
                  borderColor: '#e8f5e9',
                  animationDelay: `${0.4 + highlights.indexOf(item) * 0.1}s`
                }}
              >
                <CardContent className="pt-6 text-center">
                  <div className="inline-flex items-center justify-center w-16 h-16 rounded-full mb-4" style={{ backgroundColor: '#e8f5e9' }}>
                    <Icon style={{ color: 'var(--medical-primary)' }} size={32} />
                  </div>
                  <h3 className="text-xl font-semibold text-slate-900 mb-2">
                    {item.title}
                  </h3>
                  <p className="text-slate-600">{item.description}</p>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
